import { defineComponent, inject, computed, openBlock, createElementBlock, unref, normalizeStyle, normalizeClass, createElementVNode, Fragment, createBlock, createCommentVNode } from "vue";
import CheckedIcon from "../../assets/icons/checked.svg.js";
import MinusIcon from "../../assets/icons/minus.svg.js";
import { FORM_CONTROL_KEY } from "../form-control/type.js";
const _hoisted_1 = ["aria-disabled", "aria-checked"];
const _hoisted_2 = { class: "checkbox__input" };
const _hoisted_3 = { class: "checkbox__icon" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Checkbox",
  props: {
    modelValue: { type: Boolean, default: false },
    indeterminate: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    size: { default: "sm" },
    shape: { default: "square" },
    selectedBackground: { default: "var(--color-grey-900)" },
    checkedIconBackground: { default: "transparent" }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const { size: formControlSize, model: formControlModel } = inject(FORM_CONTROL_KEY, {});
    const handleClick = () => {
      if (props.disabled) return;
      model.value = !model.value;
    };
    const model = computed({
      get: () => {
        if (props.modelValue) return props.modelValue;
        return formControlModel?.value;
      },
      set: (val) => {
        if (formControlModel) {
          formControlModel.value = val;
        } else {
          emit("update:modelValue", val);
        }
      }
    });
    const isChecked = computed(() => {
      return !!model.value || props.indeterminate;
    });
    const size = computed(() => {
      if (props.size) return props.size;
      if (formControlSize) return formControlSize;
      return "sm";
    });
    const checkboxClasses = computed(() => {
      return [
        "checkbox",
        `checkbox--${size.value}`,
        `checkbox--${props.shape}`,
        { checked: isChecked.value, "checkbox--disabled": props.disabled }
      ];
    });
    const checkboxStyle = computed(() => ({
      "--checkbox-selected-bg": props.selectedBackground,
      "--checkbox-icon-bg": props.checkedIconBackground,
      "--checkbox-radius-sm": props.shape === "circle" ? "var(--radius-full)" : "var(--spacing-xs)",
      "--checkbox-radius-md": props.shape === "circle" ? "var(--radius-full)" : "var(--spacing-sm)"
    }));
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(unref(checkboxClasses)),
        style: normalizeStyle(unref(checkboxStyle)),
        role: "checkbox",
        "aria-disabled": __props.disabled ? "true" : void 0,
        "aria-checked": __props.indeterminate ? "mixed" : unref(model) ? "true" : "false",
        onClick: handleClick
      }, [
        createElementVNode("div", _hoisted_2, [
          createElementVNode("span", _hoisted_3, [
            unref(isChecked) ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
              !__props.indeterminate ? (openBlock(), createBlock(unref(CheckedIcon), { key: 0 })) : (openBlock(), createBlock(unref(MinusIcon), { key: 1 }))
            ], 64)) : createCommentVNode("", true)
          ])
        ])
      ], 14, _hoisted_1);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=Checkbox.vue2.js.map
